import {ReactElement} from "react";

export function AskWyzeImage({size}: { size: number }): ReactElement {
  return <div
    style={{
      width: size,
      height: size,
      backgroundColor: "#006",
      mask: `url('/images/wyze_icon.svg') no-repeat center`
    }}/>;
}